import { render, staticRenderFns } from "./Prescriptionorderlist.vue?vue&type=template&id=f3cce4e0&scoped=true&"
import script from "./Prescriptionorderlist.vue?vue&type=script&lang=js&"
export * from "./Prescriptionorderlist.vue?vue&type=script&lang=js&"
import style0 from "./Prescriptionorderlist.vue?vue&type=style&index=0&id=f3cce4e0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3cce4e0",
  null
  
)

export default component.exports